import { render, staticRenderFns } from "./PricePage.vue?vue&type=template&id=6e3f9a33&scoped=true&"
import script from "./PricePage.vue?vue&type=script&lang=js&"
export * from "./PricePage.vue?vue&type=script&lang=js&"
import style0 from "./PricePage.vue?vue&type=style&index=0&id=6e3f9a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3f9a33",
  null
  
)

export default component.exports